import React from "react";
import classes from "./Button.module.css";
import { animated } from "react-spring";

export default function Button(props) {
  let style = props.open
    ? [classes.Button, classes.ButtonOpen].join(" ")
    : [classes.Button, classes.ButtonClose].join(" ");
  return (
    <>
      <animated.button
        className={style}
        style={props.style}
        onClick={props.clicked}
      >
        <img src={props.icon} alt="" />
      </animated.button>
    </>
  );
}
